<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.orderId"
          type="text"
          placeholder="请输入订单ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.userId"
          type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入用户ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-select
          size="medium"
          v-model="searchForm.subStatus"
          placeholder="请选择状态"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          size="medium"
          v-model="searchForm.phone"
          type="text" @input="searchForm.phone = String(searchForm.phone).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入手机号"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      </div>
      <div class="searchRight">
        <!-- <el-button size="medium" type="warning" @click="getData"><i class="el-icon-setting" style="margin-right:5px;"></i>提现参数设置</el-button> -->
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="orderId"
        width="120px"
        label="订单编号">
      </el-table-column>
      <el-table-column
        width="70px"
        prop="useId"
        label="用户ID">
      </el-table-column>
      <el-table-column
        width="120px"
        prop="phone"
        label="手机号">
      </el-table-column>
      <el-table-column
        width="180px"
        prop="email"
        label="邮箱">
      </el-table-column>
      <el-table-column
        width="70px"
        prop="userName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="productName"
        width="120px"
        label="产品名称">
      </el-table-column>
       <el-table-column
        width="110px"
        prop="orderPrice"
        label="矿机租赁费用">
        <template slot-scope="scope">
          <span>{{scope.row&&scope.row.multiPrice.CNY?scope.row.multiPrice.CNY+' CNY': '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="130px"
        prop="totalPower"
        label="订单存储数(TiB)">
      </el-table-column>
      <el-table-column
        width="100px"
        prop="totalPackageCost"
        label="质押币(FIL)">
      </el-table-column>
      <el-table-column
        width="90px"
        prop="totalGasPledg"
        label="Gas(FIL)">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="160px"
        label="下单时间">
      </el-table-column>
      <el-table-column
        prop="lan"
        label="订单语言">
        <template slot-scope="scope">
          <span>{{scope.row.lan=='zh_CN'?'中文':'英文'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="350px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="orderDetail(scope.row)"><i class="el-icon-view" style="margin-right:3px;" ></i>查看详情</el-button>
          <el-button size="mini" type="primary" v-if="scope.row.subStatus==0" @click="changeStust(scope.row,1)"><i class="el-icon-circle-check" style="margin-right:3px;" ></i>通过</el-button>
          <el-button size="mini" type="warning" v-if="scope.row.subStatus==0" @click="refuse(scope.row)"><i class="el-icon-circle-close" style="margin-right:3px;" ></i>驳回订单</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.subStatus==0" @click="refuseTwo(scope.row)"><i class="el-icon-circle-close" style="margin-right:3px;" ></i>取消订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[20, 30, 40]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
    </div>
    <el-dialog
      title="对冲信息"
      :visible.sync="tradedialogVisible"
      width="800px">
      <div class="userInfo_box">
        <div class="sam_box">
          <div>订单算力数: {{tradeData.totalPower}} TiB</div>
          <div>支付实际: {{tradeData.payTime}}</div>
          <div>应对冲数: {{tradeData.tradeFilNum}} FIL</div>
        </div>
        <div class="sam_box">
          <div>用户FIL购买价: {{tradeData.priceFil}} USDT</div>
          <div>公司FIL购买价: {{tradeData.price?tradeData.price:0}} USDT</div>
          <div>当前FIL价: {{tradeData.nowPriceFil}} USDT</div>
        </div>
        <div class="sam_box">
          <div>状态: {{tradeData.tradeStatus==200?'已对冲':'待对冲'}}</div>
        </div>
        
      </div>
      <span slot="footer" class="dialog-footer" v-if="tradeData.tradeStatus!=200">
        <el-button type="primary" @click="changeTrade()">立即对冲</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="订单详情"
      :visible.sync="orderModuleDialog"
      class="nodeModules"
      width="900px">
      <div class="userInfo_box" style="margin-top: 20px;" v-if="orderData">
        <div class="sam_box">
          <div>用户ID: {{orderData.useId}}</div>
          <div>用户电话: {{orderData.phone}}</div>
          <div>用户邮箱: {{orderData.email}}</div>
        </div>
        <div class="sam_box">
          <div>产品ID: {{orderData.productId}}</div>
          <div>产品名称: {{orderData.productName}}</div>
          <div>产品类型: {{orderData.productType==1?'算力封装':'现货销售'}}</div>
        </div>
        <div class="sam_box">
          <div>扇区周期余额: {{orderData.sectorLife}} 天</div>
          <div>挖矿周期余额: {{orderData.contractLife}} 天</div>
          <div>归属渠道: {{orderData.channelName}}</div>
        </div>
        <div class="sam_box">
          <div class="txt_4">购买份数: {{orderData.num}} 份</div>
          <div class="txt_4">单份数量: {{orderData.singeNum}} TiB</div>
          <div class="txt_4">订单算力数: {{orderData.totalPower}} TiB</div>
        </div>
        <div class="sam_box">
          <div class="txt_4">矿机租赁费用: {{orderData&&orderData.multiPrice?orderData.multiPrice.CNY:'--'}} CNY</div>
          <div class="txt_4">质押币: {{orderData.totalPackageCost}} FIl</div>
          <div class="txt_4">Gas费: {{orderData.totalGasPledg}} FIl</div>
        </div>
        <div class="sam_box">
          <div class="txt_4">汇款方户名: {{orderData&&orderData.orderCny?orderData.orderCny.cardOwner:'--'}} </div>
          <div class="txt_4">收款方户名: {{orderData&&orderData.orderCny?orderData.orderCny.payeeName:'--'}}</div>
          <div class="txt_4">收款方卡号: {{orderData&&orderData.orderCny?orderData.orderCny.payeeAccount:'--'}}</div>
        </div>
        <!-- <div class="sam_box">
          <div>当前挂靠节点: {{orderData.nodeNumber}}</div>
        </div> -->
        <div class="img_box">
          <div class="txt_6">上传凭证：</div>
          <el-image :src="item" :preview-src-list="imgList" v-for="(item,index) in imgList" :key="index"></el-image>
        </div>
      </div>
      <div v-if="earningData">
        <div class="til">订单收益</div>
        <div class="sam_box">
          <div>累计收益: {{earningData.filBalance}} FIL</div>
          <div>已释放: {{earningData.incomeFilAll}} FIL</div>
          <div>待释放: {{earningData.filLocked}} FIL</div>
        </div>
      </div>
      

    </el-dialog>
    <el-dialog
      title="配置节点"
      :visible.sync="nodeModuleDialog"
      class="nodeModules"
      width="500px">
      <div v-if="nodeData">
        <!-- <div>本订单算力数：{{nodeData.totalPower}}</div> -->
        <div class="txt_2">本订单算力数：{{nodeData.totalPower}} TiB</div>
        <div class="txt_2">当前节点：{{nodeData.nodeNumber?nodeData.nodeNumber:'--'}}</div>
        <div class="txt_2">分配节点：</div>
        <div>
          <el-radio-group v-model="radio">
            <el-radio :label="item.key" v-for="(item,index) in dataArr" :key="index">
              <span class="txt_3">节点号：{{item.key}}</span>
              <span class="txt_3" style="padding-left:20px">剩余算力数：{{item.beSalePower}} TiB</span>
              
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodeModuleDialog = false">取 消</el-button>
        <el-button type="primary" @click="submint()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000)
          }
        }
      },
      nodeModuleDialog: false,
      orderModuleDialog: false,
      tradedialogVisible: false,
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        orderId: '',
        userId:'',
        phone: '',
        status: 3,
        subStatus: 0
      },
      tableData: [],
      nodeData: null,
      radio: '',
      dataArr: [],
      tradeData: {},
      orderId: '',
      orderData: {},
      earningData:{},
      num: '',
      productId: '',
      imgList: [],
      stateOptions: [
        { name: "待审核", value: 0 },
        { name: "已拒绝", value: 1 },
      ],
    };
  },
  created() {
    this.getTableList()
    
  },
  methods: {
    changeStust(row,type) {
      let txt
      if(type==1) {
        txt='此操作将通过该条人工录单, 是否继续?'
        this.$confirm(txt, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.orderAdminCheck({orderId:row.id,status:type})
          if (res) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.getTableList()
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
      }
    },
    refuse(row) {
      this.$prompt('请输入驳回原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async({ value }) => {
        console.log(value)
        let res = await this.$http.orderAdminCheck({orderId:row.id,status:3,rejectReason:value})
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    refuseTwo(row) {
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async({ value }) => {
        console.log(value)
        let res = await this.$http.orderAdminCheck({orderId:row.id,status:0,rejectReason:value})
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    async changeTrade() {
      let data = {
        id:this.orderId,
        productId:this.productId,
        num:this.num
      }
      let res = await this.$http.tradeApi(data);
      if (res) {
        console.log(res)
        this.$message.success('操作成功！');
        this.tradedialogVisible=false
        this.getTableList()
      }
    },
    orderDetail(row) {
      this.orderData = row
      this.orderId = row.id
      this.imgList = JSON.parse(row.orderCny.pictures)
      this.orderModuleDialog = true
      this.earnings()
    },
    async earnings(){
      let res = await this.$http.orderEarnings({id:this.orderId});
      if (res) {
        console.log(res)
        this.earningData = res.data
      }
    },
    async tradeDetail(row){
      this.orderId = row.id
      this.productId = row.productId
      this.num = row.num
      let res = await this.$http.tradeInfo({id:row.id});
      if (res) {
        console.log(res)
        this.tradeData = res.data
        this.tradedialogVisible = true
      }
    },
    async submint(){
      let data = {
        orderId: this.nodeData.orderId,
        oldNodeNumber: this.nodeData.nodeNumber,
        newNodeNumber: this.radio
      }
      let res = await this.$http.setNode(data);
      if (res) {
        console.log(res)
        this.$message.success('操作成功！');
        this.nodeModuleDialog=false
        this.getTableList()
      }
    },
    nodeModule(item){
      this.dataArr = []
      this.nodeData = item
      this.radio = item.nodeNumber
      this.getNodeList()
      this.nodeModuleDialog = true
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.orderList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },
    async getNodeList(){
      let res = await this.$http.nodeALL()
      if (res)
      console.log(res)
      res.data.map((x)=>{
        this.dataArr.push({
          key: x.nodeNumber,
          label: x.nodeNumber,
          beSalePower: x.beSalePower
        })
      })
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>

.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.txt_2{
  margin-bottom: 10px;
}
.txt_3{
  display: inline-block;
  width: 160px;
}
.txt_3:first-child{
  margin-right: 20px;
}
.sam_box{
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  margin-bottom: 20px;
}
.sam_box div{
  width: 250px;
  margin-right: 60px;
}
.sam_box div:nth-child(3n){
  margin-right: 0;
}
.til{
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}
.txt_4{
  font-weight: bold;
  color: #333;
}
.txt_6{
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
</style>
<style>
.nodeModules .el-dialog__body{
  padding:0  20px  20px;
}
.nodeModules .el-radio{
  width: 100%;
  margin-bottom: 20px;
}
.img_box .el-image{
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

</style>
